import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import { Link } from "react-router-dom";

import SimpleButton from "../../Buttons/SimpleButton.js";

import AboutUsHeaderImage from "../../Global/images/About-Us-Header.png";
import CarolinaSilva from "../../Global/images/CarolinaSilva.png";
import RitaSantos from "../../Global/images/RitaSantos.png";
import JulianaPereira from "../../Global/images/JulianaPereira.png";

const StyledAboutUsHeader = styled(NanoFlex)`
  gap: 32px;

  .headerTitleWrapper {
    padding: 0 100px 0 100px;
    gap: 24px;

    .headerTitle {
      h3 {
        font-weight: 500;
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
      }
    }
  }

  .imageTitleWrapper {
    position: relative;
    .imageWrapper {
      height: 350px;
      overflow: hidden;
      border-radius: 10px;
      background-color: ${(props) => props.theme.color.primaryColors.transparencyPurple};

      img {
        min-height: 100%;
        height: auto;
        width: 100%;
        object-fit: cover;
      }
    }

    .linkedInLabel {
      position: absolute;
      bottom: -1px;
      left: 100px;
      background-color: ${(props) => props.theme.color.primaryColors.white};
      height: auto;
      width: auto;
      padding: 8px 10px;
      gap: 16px;
      border-radius: 10px 10px 0 0;

      p {
        white-space: nowrap;
      }

      .teamUsers {
        .teamMember {
          height: 20px;
          width: 20px;
          border-radius: 100%;
          overflow: hidden;
          margin-left: -2px;
          box-shadow: ${(props) => props.theme.lightShaddow};

          &:first-child {
            margin-left: 0;
          }

          img {
            min-height: 100%;
            min-width: 100%;
            height: auto;
            width: auto;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    .headerTitleWrapper {
      padding: 0 50px 0 50px;
    }
    .imageTitleWrapper {
      .imageWrapper {
        height: 300px;
      }
      .linkedInLabel {
        left: 50px;
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    .headerTitleWrapper {
      padding: 0 30px 0 30px;
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    .headerTitleWrapper {
      padding: 0 10px 0 10px;
    }

    .imageTitleWrapper {
      .imageWrapper {
        height: 140px;
        border-radius: 5px;
        img {
          min-height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
    }

    .imageTitleWrapper {
      .linkedInLabel {
        left: 5px;
        border-radius: 5px 5px 0 0;
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
  }
`;

export default class AboutUsHeader extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAboutUsHeader flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="headerTitleWrapper" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
          <NanoFlex className="headerTitle" justifyContent="flex-start">
            <Type.h3>
              {this.translation.aboutUs.recruitmentSpecialists} <br />
              {this.translation.aboutUs.partnersInSuccess}
            </Type.h3>
          </NanoFlex>
          <NanoFlex className="headerButton" justifyContent="flex-start">
            <Link to="#contacts">
              <SimpleButton darkPurple label={this.translation.aboutUs.headerButtonText}></SimpleButton>
            </Link>
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="imageTitleWrapper">
          <NanoFlex className="imageWrapper">
            <img src={AboutUsHeaderImage} alt="Chase Up Team" />
          </NanoFlex>
          <NanoFlex className="linkedInLabel">
            <NanoFlex className="teamUsers">
              <NanoFlex className="teamMember">
                <img src={CarolinaSilva} alt="Carolina Silva" />
              </NanoFlex>
              <NanoFlex className="teamMember">
                <img src={JulianaPereira} alt="Juliana Pereira" />
              </NanoFlex>
              <NanoFlex className="teamMember">
                <img src={RitaSantos} alt="Rita Santos" />
              </NanoFlex>
            </NanoFlex>
            <Type.p>
              {this.translation.aboutUs.weAre} <b>2.476</b> {this.translation.aboutUs.inLinkedIn}
            </Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledAboutUsHeader>
    );
  }
}
